export default [
    { id: 1, name: "Medicinal" },
    { id: 2, name: "Tóxica" },
]